import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { RequiresPermissionsModule } from '../directives';
import { TripChatDetailComponent } from './trip-chat-detail.component';

@NgModule({
  declarations: [TripChatDetailComponent],
  imports: [CommonModule, ReactiveFormsModule, MatCardModule, MatButtonModule, MatInputModule, MatIconModule, RequiresPermissionsModule],
  exports: [TripChatDetailComponent]
})
export class TripChatDetailModule {}
